import { ChoicePicker, ChoicePickerOption } from "./ChoicePicker";
import { useTranslation } from "react-i18next";


interface DigitalTargetPickerProps {
    setDigitalTarget: (data: any) => void;
    required?: boolean;
    value: DigitalTargetOption[] | undefined;
}

export interface DigitalTargetOption extends ChoicePickerOption {
    id: string;
    name: string
}

export const DigitalTargetPicker = (props: DigitalTargetPickerProps) => {
    const { t } = useTranslation();
    
    const data: ChoicePickerOption[] = [
        {id: "notoriety", name: t("txt_digital_target_notoriety")},
        {id: "engagement", name: t("txt_digital_target_engagement")},
        {id: "conversion", name: t("txt_digital_target_conversion")},
        {id: "drive-to-store", name: t("txt_digital_target_drive-to-store")},
        {id: "drive-to-web", name: t("txt_digital_target_drive-to-web")},
        {id: "downloads", name: t("txt_digital_target_downloads")},
    ]

    return (
        <ChoicePicker
            setSelectedData={props.setDigitalTarget}
            placeholder={t("txt_digital_target")}
            data={data}
            multiple={true}
            required={props.required}
            controlId="digitalTargetPicker"
            value={props.value ? props.value : []}
        />
);
}